
<template>
  <!--新品选品库-->
  <x-addEdit
    apiOrigin="PHP"
    :formList="formList"
    :formKey="formKey"
    :addParam="addParam"
    :editParam="editParam"
    :detailParam="detailParam"
  >
  </x-addEdit>
</template>

<script>
export default {
  name: 'addWarehouse',
  data () {
    return {
      formList: [
        {
          label: '标题',
          inputType: 'input',
          options: [],
          placeholder: '请输入标题',
          props: ['title', {
            rules: [
              { required: true, message: '请输入标题' },
              { min: 1, max: 20, message: '请输入标题' },
              {pattern: this.REG.nonEmpty, message: this.MESSAGE.nonEmpty}
            ]
          }]
        },
        {
          label: '副标题',
          inputType: 'input',
          options: [],
          placeholder: '请输入副标题',
          props: ['subtitle', {
            rules: [
              { min: 1, max: 20, message: '请输入副标题' }
            ]
          }]
        },
        {
          label: '排序',
          inputType: 'input',
          options: [],
          placeholder: '请输入排序',
          type: 'number',
          props: ['sort', {
            rules: []
          }]
        }
      ],
      formKey: {
        title: '',
        subtitle: '',
        sort: ''
      },
      addParam: {
        url: '/market/goods_warehouse',
        reqHandle: '', // this.reqHandle
        resHandle: '' // this.addResHandle
      },
      editParam: {
        url: '/market/goods_warehouse/',
        resHandle: '' // this.editResHandle
      },
      detailParam: {
        url: '/market/goods_warehouse/',
        resHandle: ''
      }
    };
  },
  mounted () {
  },
  methods: {
    detailResHandle (data) {
      return data;
    },
    reqHandle (param) {
      console.log('处理请求前数据: ', param);
      return param;
    },
    addResHandle (res) {
      console.log('处理添加返回数据: ', res);
      return res;
    },
    editResHandle (res) {
      console.log('处理编辑返回数据: ', res);
      return res;
    }
  }
};
</script>
